import {Chip} from "@mui/material";
import React from "react";


const StationFeatureChip = ({feature, onDelete}) => {
    {
        let s = "-"
        if (feature.properties?.date) {
            s = `${feature.properties?.date} (${feature.properties?.locationName})`
        }
        return <Chip label={s}
                     size="small"
                     color="primary"
                     onDelete={onDelete}/>
    }
}


export default StationFeatureChip;